export default {

  methods: {
    isDrawerOpen(shift) {
      if (!shift) {
        return false
      }

      if (shift.status == 'o') {
        return true
      }
    },

    getDrawerText(shift) {
      if (this.isDrawerOpen(shift)) {
        return 'Caixa Aberto'
      }

      return 'Caixa Fechado'
    },

    getStartedAtText(shift) {
      if (shift) {
        let text = 'Aberto por ' + shift.started_by_user.name + ' às ' + this.toDateTimeBr(shift.started_at) 
        
        return text
      }
    },

    getEndedAtText(shift) {
      if (shift) {
        let text = 'Fechado por ' + shift.started_by_user.name + ' às ' + this.toDateTimeBr(shift.started_at) 
        
        return text
      }
    }
  }

}